import { Component } from '@angular/core';
import { DialogBaseViewComponent, SimpleDialogData } from '@sb/library/base';

@Component({
    selector: 'lib-dialog-delete',
    templateUrl: './dialog-delete.component.html',
    styleUrls: ['./dialog-delete.component.scss'],
})
export class DialogDeleteComponent extends DialogBaseViewComponent<SimpleDialogData> {
    get primaryButtonText(): string {
        return this.data.PrimaryButtonText ?? $localize`:@@CommonDeleteButton:Delete`;
    }

    get secondaryButtonText(): string {
        return this.data.SecondaryButtonText ?? $localize`:@@CommonCancelButton:Cancel`;
    }
}
